module.exports = __webpack_public_path__ + "img/icon8.e375c938.png";